import createSpinner from "../../../../../Shared/Functions/createSpinner";
import { standardGridPageSize } from "../../../../../Shared/GlobalVariables/filterVariables";

export default /*@ngInject*/ function (reviewSchedulesDataService, reviewAssignmentsDataService, $filter, $uibModalInstance, schedule, isClone, helperService, maintainSystemRolesDataService, roleTemplatesData, dataService) {
    const vm = this;
    vm.isClone = isClone;

    vm.saveSchedule = saveSchedule;
    vm.dismiss = dismiss;
    vm.resetDropdowns = resetDropdowns;

    vm.schedule = { ...schedule };

    activate();

    async function activate() {
        if (vm.schedule.Id) {
            vm.schedule.RoleIdentifiers = vm.schedule.Roles.map(role => role.SecurityRoleIdentifier);
            vm.schedule.RoleTemplateIdentifiers = vm.schedule.RoleTemplates.map(role => role.RoleTemplateId);
            vm.schedule.ProductIds = vm.schedule.Products.map(product => product.ProductId);
        }

        if (isClone) {
            vm.scheduleInstanceId = vm.schedule.Id;
            vm.schedule.Name = '';
            vm.schedule.Description = '';
        } else {
            getReviewTypes();
        }

        await setupRolesDropdown();
        await setupRoleTemplatesDropdown();
        await setupProductsDropdown();
    }

    async function getReviewTypes() {
        const response = await reviewAssignmentsDataService.getReviewTypes();
        vm.scheduleTypesDataSource = response.data;
    }

    function resetDropdowns() {
        vm.schedule.RoleIdentifiers = [];
        vm.schedule.RoleTemplateIdentifiers = [];
        vm.schedule.ProductIds = [];

        if (!vm.schedule.IncludeSupervisorReviews) {
            vm.schedule.RestrictSupervisorReviewItems = false;
        }
    }

    async function saveSchedule() {
        vm.saveInProgress = new createSpinner();
        let scheduleInstance = {
            Name: vm.schedule.Name,
            Description: vm.schedule.Description,
            ReviewType: vm.schedule.ReviewType,
            IncludeSupervisorReviews: vm.schedule.IncludeSupervisorReviews,
            IncludeCompanyInReviews: vm.schedule.IncludeCompanyInReviews,
            RestrictSupervisorReviewItems: vm.schedule.RestrictSupervisorReviewItems,
            RoleIdentifiers: vm.schedule.RoleIdentifiers,
            RoleTemplateIdentifiers: vm.schedule.RoleTemplateIdentifiers,
            ProductIds: vm.schedule.ProductIds
        }
        if (vm.schedule.Id && !isClone) {
            updateScheduleInstance(scheduleInstance);
        } else if (isClone) {
            cloneScheduleInstance(scheduleInstance);
        }
        else {
            createScheduleInstance(scheduleInstance);
        }
    }

    function setupRolesDropdown() {
        vm.rolesDropdownOptions = {
            filter: "contains",
            autoClose: false,
            virtual: {
                itemHeight: 26,
                mapValueTo: 'dataItem',
                valueMapper: options => {
                    options.success(helperService.multiValueMapperFunction(options, vm.rolesDataSource, 'Identifier'));
                }
            },
            height: 325,
            placeholder: `-- Select one or more Roles --`
        };

        vm.rolesDropdownDataSource = new kendo.data.DataSource({
            pageSize: standardGridPageSize,
            transport: {
                read: async (options) => {
                    vm.rolesDropdownLoading = true;
                    let { data } = await maintainSystemRolesDataService.getSystemRolesNonPaged();
                    vm.rolesDataSource = $filter('orderBy')(data, 'Name');
                    options.success(vm.rolesDataSource);
                    vm.rolesDropdownLoading = false;
                }
            }
        });
    }

    function setupRoleTemplatesDropdown() {
        vm.roleTemplatesDropdownOptions = {
            filter: "contains",
            autoClose: false,
            virtual: {
                itemHeight: 26,
                mapValueTo: 'dataItem',
                valueMapper: options => {
                    options.success(helperService.multiValueMapperFunction(options, vm.roleTemplatesDataSource, 'Id'));
                }
            },
            height: 325,
            placeholder: `-- Select one or more Role Templates --`
        };

        vm.roleTemplatesDropdownDataSource = new kendo.data.DataSource({
            pageSize: standardGridPageSize,
            transport: {
                read: async (options) => {
                    vm.roleTemplatesDropdownLoading = true;
                    let { data } = await roleTemplatesData.getRoleTemplates();
                    vm.roleTemplatesDataSource = $filter('orderBy')(data, 'Name');
                    options.success(vm.roleTemplatesDataSource);
                    vm.roleTemplatesDropdownLoading = false;
                }
            }
        });
    }

    function setupProductsDropdown() {
        vm.productsDropdownOptions = {
            filter: "contains",
            autoClose: false,
            virtual: {
                itemHeight: 26,
                mapValueTo: 'dataItem',
                valueMapper: options => {
                    options.success(helperService.multiValueMapperFunction(options, vm.productsDataSource, 'ID'));
                }
            },
            height: 325,
            placeholder: `-- Select one or more Products --`
        };

        vm.productsDropdownDataSource = new kendo.data.DataSource({
            pageSize: standardGridPageSize,
            transport: {
                read: async (options) => {
                    vm.productsDropdownLoading = true;
                    let { data } = await dataService.getProducts();
                    vm.productsDataSource = $filter('orderBy')(data, 'Name');
                    options.success(vm.productsDataSource);
                    vm.productsDropdownLoading = false;
                }
            }
        });
    }

    async function createScheduleInstance(scheduleInstance) {
        try {
            const response = await reviewSchedulesDataService.createInstance(scheduleInstance)
            await helperService.successfulSaveButton(vm.saveInProgress);
            close(response.data);
        } catch {
            vm.saveInProgress.loadingValue = false;
        }
        
    }

    async function cloneScheduleInstance(scheduleInstance) {
        scheduleInstance.ReviewInstanceId = vm.scheduleInstanceId;

        try {
            const response = await reviewSchedulesDataService.cloneInstance(scheduleInstance)
            await helperService.successfulSaveButton(vm.saveInProgress);
            close(response.data);
        } catch {
            vm.saveInProgress.loadingValue = false;
        }

    }

    async function updateScheduleInstance(scheduleInstance) {
        scheduleInstance.Id = vm.schedule.Id;
        scheduleInstance.ReviewType = vm.schedule.ReviewType;
        try {
            await reviewSchedulesDataService.updateInstance(scheduleInstance)
            await helperService.successfulSaveButton(vm.saveInProgress);
            close();
        } catch {
            vm.saveInProgress.loadingValue = false;
        }
    }

    function close(newInstanceId) {
        $uibModalInstance.close(newInstanceId);
    }

    function dismiss() {
        $uibModalInstance.dismiss();
    }
}